export default {
  campaign: () => import("/codebuild/output/src3183640832/src/consort-headless/nuxtapp/layouts/campaign.vue"),
  default: () => import("/codebuild/output/src3183640832/src/consort-headless/nuxtapp/layouts/default.vue")
}